function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  strokeWidth: "1.4px",
  d: "M4,33.2c0-1.7,1-3.2,2.6-3.9,1.6-.7,3.4-.3,4.6.9l57.6,57.6c1.2,1.2,1.6,3,.9,4.6-.7,1.6-2.2,2.6-3.9,2.6H11.2c-4,0-7.2-3.2-7.2-7.2v-54.6ZM11.2,93.2h54.6c1.2,0,1.9-.8,2.2-1.5.3-.7.3-1.8-.5-2.6l-2.3-2.3-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-6.1-6.1-3.2,3.2c-.2.2-.4.3-.6.3s-.5,0-.6-.3c-.4-.4-.4-.9,0-1.3l3.2-3.2-2.3-2.3c-.5-.5-1.1-.7-1.7-.7s-.7,0-.9.2c-.7.3-1.5,1-1.5,2.2v54.6c0,3,2.4,5.4,5.3,5.4Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M41.6,84.5h-24.6c-1.4,0-2.5-1.1-2.5-2.5v-24.6c0-1,.6-1.9,1.5-2.3.9-.4,2-.2,2.7.5l24.6,24.6c.7.7.9,1.8.5,2.7-.4.9-1.3,1.5-2.3,1.5ZM17.5,81.5h22.9l-22.9-22.9v22.9Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M70.4,66.1c-.7-.7-.7-1.9,0-2.7.7-.7,1.9-.7,2.7,0l2.3,2.3c.7.7.7,1.9,0,2.7-.7.7-1.9.7-2.7,0l-2.3-2.3ZM62.7,58.3c-.7-.7-.7-1.9,0-2.7.7-.7,1.9-.7,2.7,0l2.3,2.3c.7.7.7,1.9,0,2.7-.7.7-1.9.7-2.7,0l-2.3-2.3ZM54.9,50.6c-.7-.7-.7-1.9,0-2.7.7-.7,1.9-.7,2.7,0l2.3,2.3c.7.7.7,1.9,0,2.7-.7.7-1.9.7-2.7,0l-2.3-2.3ZM47.1,42.8c-.7-.7-.7-1.9,0-2.7.7-.7,1.9-.7,2.7,0l2.3,2.3c.7.7.7,1.9,0,2.7-.7.7-1.9.7-2.7,0l-2.3-2.3ZM39.4,35c-.7-.7-.7-1.9,0-2.7.7-.7,1.9-.7,2.7,0l2.3,2.3c.7.7.7,1.9,0,2.7-.7.7-1.9.7-2.7,0l-2.3-2.3ZM31.6,27.3c-.7-.7-.7-1.9,0-2.7.7-.7,1.9-.7,2.7,0l2.3,2.3c.7.7.7,1.9,0,2.7-.7.7-1.9.7-2.7,0l-2.3-2.3Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M33.2,15.2c0-1-.9-1.9-1.8-2.1h-.2s-5.9-.6-9.7-1c-1.1-.1-2.1.9-2.1,2l.6,9.9c.1,1,1,1.7,2,1.6.9,0,1.8-.8,1.8-1.8l-.3-4.8s2,2,2.9,2.9c.7.7,1.9.8,2.7,0,.8-.7.8-1.9,0-2.7l-2.9-2.9,4.6.5h.2c1.1,0,2.1-.7,2.2-1.7Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M72.5,76.6c0,1,1,1.9,1.9,2h.2s5.9.5,9.7.8c1.1,0,2.1-.9,2-2l-.8-9.9c-.2-.9-1-1.6-2-1.6-.9,0-1.7.9-1.7,1.8l.4,4.8s-2.1-2-2.9-2.8c-.7-.7-1.9-.7-2.7,0-.7.7-.7,1.9,0,2.7l2.9,2.8-4.6-.4h-.2c-1.1,0-2.1.7-2.1,1.7Z"
});

var SvgIcoSimulationMode = function SvgIcoSimulationMode(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 87 114",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationMode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_mode.34ca2cf8.svg";
export { ForwardRef as ReactComponent };